import { render, staticRenderFns } from "./TaskInfoDrawer.vue?vue&type=template&id=6d24f84e&scoped=true"
import script from "./TaskInfoDrawer.vue?vue&type=script&lang=js"
export * from "./TaskInfoDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d24f84e",
  null
  
)

export default component.exports